import { TextField } from "@mui/material";

interface TextFieldDEProps {
  value: string;
  label?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onFocus?: () => void;
}

export const TextFieldDE = ({
  value,
  label,
  disabled = false,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
}: TextFieldDEProps) => {
  return (
    <TextField
      fullWidth
      disabled={disabled}
      label={label}
      variant={"outlined"}
      value={value || ""}
      onFocus={onFocus}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onBlur(value);
        }
      }}
      onBlur={() => {
        onBlur(value);
      }}
      style={{
        minWidth: "50px",
      }}
    />
  );
};
